import { createRef } from 'react';

import type { ICouponState } from './coupon.interfaces';

export const initialState: ICouponState = {
  placeholderTerms: createRef(),
  showUnavailableCoupon: false,
  applicableCoupon: false,
  shouldRenderCoupon: false,
};
